import dayjs from "dayjs";

export const LOCAL_STORAGE_KEY = "_app_state"

export const ActionType = {
    SetApiEndpoint: "SET_API_ENDPOINT",
    SetUser: "SET_USER",
    SetEnv: "SET_ENV",
    SetColumnDefs: "SET_COLUMN_DES",
    SetDirection: "SET_DIRECTION",
    SetViewMode: "SET_VIEW_MODE",
    SetCondition: "SET_CONDITION",
    RefreshTreeLayer: "REFRESH_TREE_LAYER",
    SetTreeInfoModel: "SET_TREE_INFO_MODEL",
    SetFilterModel: "SET_FILTER_MODEL",
    SetSelectedTreeModel: "SET_SELECTED_TREE_MODEL",
    SetTabMode: "SET_TAB_MODE",
}

const AppDataReducer = (state, action) => {

    switch(action.type) {
        case ActionType.SetApiEndpoint:
            state = {...state, apiEndpoint: action.value}
            break
        case ActionType.SetUser:
            state = {...state, user: action.value}
            break
        case ActionType.SetEnv:
            state = {...state, env: action.value}
            break
        case ActionType.SetColumnDefs:
            state = {...state, columnDefs: action.value}
            break
        case ActionType.SetDirection:
            state = {...state, direction: action.value}
            break
        case ActionType.SetViewMode:
            state = {...state, viewMode: action.value}
            break
        case ActionType.SetCondition:
            state = {...state, condition: action.value}
            break
        case ActionType.RefreshTreeLayer:
            state = {
                ...state,
                treeRefreshTime: dayjs().unix()
            }
            break
        case ActionType.SetTreeInfoModel:
            return {...state, treeInfoModel: action.value}
        case ActionType.SetFilterModel:
            state = {...state, filterModel: action.value}
            break
        case ActionType.SetSelectedTreeModel:
            return {...state, selectedTreeModel: action.value}
        case ActionType.SetTabMode:
            return {...state, tabMode: action.value}
        default:
            return state
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
        ...state,
        treeInfoModel: null,
        selectedTreeModel: null,
    }))

    return state
}

export default AppDataReducer

